<span>
    <ng-template #tipContent style="text-align:left">
        <h2>{{parameter.displayName != null  ? parameter.displayName : parameter.name}}</h2>  
        <p>{{parameter.description}}</p>
        <h3 *ngIf="parameter.defaultValue && parameter.defaultValue.length > 0" >Default Value</h3>
        <code *ngIf="parameter.defaultValue && parameter.defaultValue.length > 0" ><pre>{{parameter.defaultValue}}</pre></code>
        <h3 *ngIf="parameter.example && parameter.example.length > 0" >Example</h3>
        <code *ngIf="parameter.example && parameter.example.length > 0" ><pre>{{parameter.example}}</pre></code>
    </ng-template>
    <label>

        {{parameter.displayName != null  ? parameter.displayName : parameter.name}}
        
        <button triggers="focus" *ngIf="parameter.description && parameter.description.length > 5" placement="auto" containerClass="bg-dark bg-opacity-90 border-info text-info" hea
            [popover]="tipContent" class="btn btn-xs btn-outline-default rounded-circle" type="button">
            <i class="fa fa-info"></i>
        </button>
        
    </label>
    <div class="input-group input-group-sm mb-3 mt-1" *ngIf="parameter && configItem">

        <div class="form-check form-switch" *ngIf="parameter.type == 0">
            <input type="checkbox" class="form-check-input" id="editWidgetSwitch" [(ngModel)]="configItem.value"/>
        </div>

        <!-- STRING -->
        <input *ngIf="parameter.type == 1" type="text" title="{{parameter.displayName ? parameter.displayName : parameter.name}}"
               placeholder="Enter {{parameter.displayName ? parameter.displayName : parameter.name}}"
               [(ngModel)]="configItem.value"
               [disabled]="!enabled"
               class="form-control">

        <!-- INTEGER -->
        <input *ngIf="parameter.type == 2 || parameter.type == 3" type="number" title="{{parameter.displayName ? parameter.displayName : parameter.name}}"
               placeholder="Enter {{parameter.displayName ? parameter.displayName : parameter.name}}"
               [(ngModel)]="configItem.value"
               [disabled]="!enabled"
               class="form-control">

        <!-- DATETIME -->
        <input *ngIf="parameter.type == 4" type="datetime" title="{{parameter.displayName ? parameter.displayName : parameter.name}}"
               placeholder="Enter {{parameter.displayName ? parameter.displayName : parameter.name}}"
               [(ngModel)]="configItem.value"
               [disabled]="!enabled"
               class="form-control">

        <!-- TIMESPAN -->
        <!-- todo: implement timespan editor -->
        <input *ngIf="parameter.type == 5" type="datetime" title="{{parameter.displayName ? parameter.displayName : parameter.name}}"
               placeholder="Enter {{parameter.displayName ? parameter.displayName : parameter.name}}"
               [(ngModel)]="configItem.value"
               [disabled]="!enabled"
               class="form-control">

        <!-- PASSWORD -->
        <input *ngIf="parameter.type == 6" type="password" title="{{parameter.displayName ? parameter.displayName : parameter.name}}"
               placeholder="Enter {{parameter.displayName ? parameter.displayName : parameter.name}}"
               [(ngModel)]="configItem.value"
               [disabled]="!enabled"
                class="form-control">

        <!-- Select List -->
        <select *ngIf="parameter.type == 9" class="input-group form-select" [(ngModel)]="configItem.value" [disabled]="!enabled">
            <option *ngFor="let option of parameter.allowedValues" value="{{option.key}}">{{option.value}}</option>
        </select>

        <!-- Period -->
        <app-time-period *ngIf="parameter.type == 21" [(period)]="configItem.value" (periodChange)="timeChange()" [type]="'text'" [size]="'md'"></app-time-period>
    </div>
</span>
